/**
 * /app/$tenantSlug/settings/onboarding-templates — the old Onboarding
 * Templates page. Checklist templates for every stage now live at
 * Settings › People › Checklists (migration 170), so this URL redirects to
 * its Onboarding tab.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/onboarding-templates",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/settings/checklists/onboarding",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
